import { EventListener } from '../Services/event-listener';
import { isValidUrlForApp } from '../Services/utils';
var IframeCommunicationBridge = /** @class */ (function () {
    function IframeCommunicationBridge(logger) {
        var _this = this;
        this.logger = logger;
        /**
         * gets the origin of the hosted app
         */
        this.getOrigin = function () { return _this.origin; };
    }
    /**
     * sets the origin of the hosted app
     */
    IframeCommunicationBridge.prototype.setOrigin = function (origin) {
        this.origin = origin;
    };
    IframeCommunicationBridge.prototype.onSdkInitialized = function (hostWindow) {
        this.hostEventListener = new EventListener(hostWindow);
        this.hostEventListener.addListener('message', this.onMessageReceived.bind(this));
    };
    IframeCommunicationBridge.prototype.onSetFrameAndLoadOrigin = function (frame, origin, appDefinition, appContext, handleMessageCallback) {
        this.frame = frame;
        this.setOrigin(origin);
        this.appDefinition = appDefinition;
        this.appContext = appContext;
        this.handleMessageCallbackIframe = handleMessageCallback;
    };
    IframeCommunicationBridge.prototype.postMessage = function (target, message) {
        var origin = this.getOrigin();
        if (origin) {
            if (target.contentWindow) {
                target.contentWindow.postMessage(message, origin);
            }
        }
    };
    IframeCommunicationBridge.prototype.onMessageReceived = function (event) {
        // The message event originated from an unknown frame
        if (!this.frame || this.frame.contentWindow !== event.source) {
            return;
        }
        var sourceOrigin = event.origin;
        if (sourceOrigin &&
            sourceOrigin !== this.getOrigin() &&
            isValidUrlForApp(sourceOrigin, this.logger, this.appDefinition, this.appContext)) {
            this.setOrigin(sourceOrigin);
        }
        if (this.getOrigin() === sourceOrigin && this.handleMessageCallbackIframe) {
            this.handleMessageCallbackIframe(event);
        }
    };
    IframeCommunicationBridge.prototype.dispose = function () {
        var _a;
        (_a = this.hostEventListener) === null || _a === void 0 ? void 0 : _a.removeAllListeners();
    };
    return IframeCommunicationBridge;
}());
export { IframeCommunicationBridge };
//# sourceMappingURL=iframe-communication-bridge.js.map